import { useState, useEffect } from 'react';
import ProfileMenu from './adminprofilemenu';
import { useSidebar } from './SidebarContext';

const Navbar = () => {
  const isLoggedIn = localStorage.getItem('token');
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  const { isSidebarOpen, setIsSidebarOpen } = useSidebar();

  const sidebarWidth = isSidebarOpen ? '15.6rem' : '4.4rem';
  const contentWidth = isSidebarOpen ? 'calc(100% - 15.6rem)' : 'calc(100% - 4rem)';

  // Define alertStyle
  const alertStyle = {
    backgroundColor: '#ffe4e6',
    color: '#dc2626',
    padding: '0.5rem 1rem',
    borderRadius: '0.25rem',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    fontFamily: "'Roboto', sans-serif",
    fontSize: '0.875rem',
  };

  // Define closeButtonStyle
  const closeButtonStyle = {
    background: 'none',
    border: 'none',
    fontSize: '1rem',
    cursor: 'pointer',
    color: '#dc2626',
    fontFamily: "'Roboto', sans-serif",
  };

  return (
    <div
      style={{
        width: contentWidth,
        height: '3.5rem',
        backgroundColor: '#fff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: '2.2rem',
        paddingLeft: '0',
        position: 'fixed',
        top: 0,
        left: sidebarWidth,
        zIndex: 1000,
        transition: 'all 0.3s ease',
        fontFamily: "'Roboto', sans-serif",
      }}
    >
      <div style={{ marginLeft: '1rem' }}>
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            color: '#334155',
            fontFamily: "'Roboto', sans-serif",
          }}
        >
          ☰
        </button>
      </div>

      {error && (
        <div style={alertStyle}>
          <span>{error}</span>
          <button
            style={closeButtonStyle}
            onClick={() => setError('')}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      )}

      {/* RIGHT SIDE: Profile only (MessageBox removed) */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
        {user && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <img
              src="/Uploads/admin-profile-image.png"
              alt="User Profile"
              style={{ width: '2.5rem', height: '2.5rem', borderRadius: '50%' }}
            />
            <span style={{ fontFamily: "'Roboto', sans-serif" }}>{user.name}</span>
          </div>
        )}
        <ProfileMenu />
      </div>
    </div>
  );
};

export default Navbar;